module.exports = __webpack_public_path__ + "static/media/arrow-icon.52ace428.svg";